import React from "react";
import './assets/css/hack-o-relay-themes.css'
const Hack_o_relay_themes=()=>{
    return(
        <section className="themes">
            <h1 className="heading">Problem statements/ Themes</h1>

            <div className="row">
                <div className="col-sm-12">
                    <h1>T r a c k 1</h1>
                    <h3>Content Creation</h3>
                    <ol>
                        <li>What is deep learning? Explain how it works using a real life example.</li>
                        <li>How can gamification enter our classrooms and transform the educational system as a whole?</li>
                        <li>How is virtual reality (VR) and augmented reality (AR) expected to be further integrated in our lives in 2030?</li>
                        <li>How is the cloud the backbone of Google?</li>
                        <li>Let’s Innovate (Create a video on any technical Concept. It should cover any domain specifically.)</li>
                    </ol>
                </div>
                <div className="col-sm-12">
                    <h1>T r a c k 2</h1>
                    <h3>Prototyping/Wireframing </h3>
                    <ol>
                        <li>Create a music player</li>
                        <li>A wallet app to securely store travel documents</li>
                        <li>Improve any social media app with a new, innovative feature, which stands out from other apps.</li>
                        <li>Blogging App</li>
                        <li>Let’s Innovate (Open Innovation)</li>
                    </ol>
                </div>
                <div className="col-sm-12">
                    <h1>T r a c k 3</h1>
                    <h3>Development </h3>
                    <ol>
                        <li>E-sports</li>
                        <li>Cosmos</li>
                        <li>Basic utility (eg urban clap)</li>
                        <li>Healthcare</li>
                        <li>Let’s Innovate (Open Innovation)</li>
                    </ol>
                </div>
            </div>



            <div className="submission guidelines">
                <a href="https://docs.google.com/document/d/1ZsJwJK91HXp6LJQetC83LfJtHtt2jJxQLHMvutjRQ3A/edit?usp=sharing">Submission guidelines</a>
            </div>
        </section>
    );
}
export default Hack_o_relay_themes;